import { render, staticRenderFns } from "./fixed.vue?vue&type=template&id=3da37b9e&"
import script from "./fixed.vue?vue&type=script&lang=ts&"
export * from "./fixed.vue?vue&type=script&lang=ts&"
import style0 from "./fixed.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports